import { render, staticRenderFns } from "./ChatAppItem.vue?vue&type=template&id=8665ec74&"
import script from "./ChatAppItem.vue?vue&type=script&lang=js&"
export * from "./ChatAppItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports